import { jsx as o, jsxs as l } from "react/jsx-runtime";
import * as g from "@radix-ui/react-tabs";
import c from "classnames";
import p from "./index.es5847.js";
import { SimpleTooltip as f } from "./index.es127.js";
const b = ({
  id: s,
  LeftIcon: e,
  label: t,
  disabled: i = !1,
  tooltip: r,
  testId: a
}) => {
  const m = c(p.trigger);
  return /* @__PURE__ */ o(f, { title: r, isActive: !!r, children: /* @__PURE__ */ l(
    g.Trigger,
    {
      disabled: i,
      className: m,
      value: s,
      "data-testid": a,
      children: [
        e,
        t
      ]
    }
  ) });
};
export {
  b as BaseTabTrigger
};
//# sourceMappingURL=index.es5626.js.map
